import React from 'react';
import styles from '../../styles/cr.module.scss';
import { ITextFieldStyles, TextField } from '@fluentui/react/lib/TextField';
import { TextFieldCharCounter, FieldHistory, FieldErrorMessage, FieldDescriptionAbove, FieldDescriptionBelow } from './FieldDecorators';
import { CrLabel } from './CrLabel';
import { type } from 'os';

export interface ICrTextFieldProps {
    label?: string;
    labelIcon?: string;
    className?: string;
    style?: React.CSSProperties;
    styles?: Partial<ITextFieldStyles>;
    value?: string;
    disabled?: boolean;
    required?: boolean;
    placeholder?: string;
    multiline?: boolean;
    readonly?: boolean;
    rows?: number;
    type?: string | undefined;
    maxLength?: number;
    //onChange?: (value: string) => void;
    onChange?: (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => void;
    history?: string;
    charCounter?: boolean;
    errorMessage?: string;
    suffix?: string;
    canRevealPassword?: boolean;
    autoComplete?: string;
    onBlur?: (ev: any) => void;
}

export const CrTextField = (
    { label, labelIcon, placeholder, value, required, className, style, styles: textFieldStyles, errorMessage, onChange, onBlur, maxLength, charCounter, history, multiline, readonly, type, canRevealPassword, autoComplete, ...otherProps }: ICrTextFieldProps
): React.ReactElement => {
    return (
        <div className={className} style={style}>
            {label &&
                <CrLabel
                    text={label}
                    required={required}
                    icon={labelIcon || (multiline ? `AlignLeft` : `TextField`)}
                />
            }
            {placeholder && multiline &&
                <FieldDescriptionAbove value={placeholder} />
            }
            <TextField
                {...otherProps}
                styles={textFieldStyles}
                placeholder={/*!multiline && */placeholder}
                value={value}
                maxLength={maxLength}
                multiline={multiline}
                readOnly={readonly}
                type={type}
                className={errorMessage && styles.textFieldInvalid}
                canRevealPassword={canRevealPassword}
                autoComplete={autoComplete}
                //onChange={(_e, v) => onChange(_e, v)}
                onChange={onChange ? (_e, v) => onChange(_e, v) : undefined}
                onBlur={onBlur}
            />
            {charCounter && maxLength &&
                <TextFieldCharCounter maxChars={maxLength} text={value} />
            }
            {placeholder && !multiline && value != null && value !== '' &&
                <FieldDescriptionBelow value={placeholder} />
            }
            {history &&
                <FieldHistory value={history} />
            }
            {errorMessage &&
                <FieldErrorMessage value={errorMessage} />
            }
        </div>
    );
};
